/* tslint:disable */
/* eslint-disable */
/**
 * ANEP Device Provisioning API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HTTPValidationError,
} from '../models/index';
import {
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
} from '../models/index';

export interface ApiGetConfV1ConfDeviceIdGetRequest {
    deviceId: string;
}

/**
 * 
 */
export class ConfApi extends runtime.BaseAPI {

    /**
     * Permet de récupérer la configuration d\'un équipement. Pas de token nécessaire sur v1
     * Api Get Conf
     */
    async apiGetConfV1ConfDeviceIdGetRaw(requestParameters: ApiGetConfV1ConfDeviceIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling apiGetConfV1ConfDeviceIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/conf/{device_id}`;
        urlPath = urlPath.replace(`{${"device_id"}}`, encodeURIComponent(String(requestParameters['deviceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Permet de récupérer la configuration d\'un équipement. Pas de token nécessaire sur v1
     * Api Get Conf
     */
    async apiGetConfV1ConfDeviceIdGet(requestParameters: ApiGetConfV1ConfDeviceIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.apiGetConfV1ConfDeviceIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
